module.exports = __webpack_public_path__ + "img/2_1-commerciale-cinema-2.dbd12a07.png";